var $windowsize = {
  // ======================================================================
  // OPTIONS
  // ======================================================================

  use: true,
  freq: 100,
  isDesktop: null,
  devVH: false,

  // ======================================================================
  // VARS
  // ======================================================================

  initedNavResize: false,
  timeout: null,
  w: 0,
  h: 0,
  r: 0,
  w2: 0,
  h2: 0,
  r2: 0,

  // ======================================================================
  // RUN
  // ======================================================================

  run: function(instant, force) {
    if ($windowsize.use == true) {
      if (typeof force === 'undefined') {
        force = instant ? true : false;
      }
      if (instant == true) {
        $windowsize.func(force);
      } else {
        clearTimeout($windowsize.timeout);
        $windowsize.timeout = setTimeout(function() {
          $windowsize.func(force);
        }, $windowsize.freq);
      }
    }
  },
  func: function(force) {
    console.log('%c--- windowsize ---', 'color:#DDD6AA');
    var oldWidth = $windowsize.w;
    var oldHeight = $windowsize.h;
    var oldWidth2 = $windowsize.w2;
    var oldHeight2 = $windowsize.h2;
    $windowsize.w = $(window).width();
    $windowsize.h = $(window).height();
    // $windowsize.r = $windowsize.w / $windowsize.h;
    // $windowsize.w2 = window.innerWidth ? window.innerWidth : $windowsize.w;
    $windowsize.h2 = window.innerHeight ? window.innerHeight : $windowsize.h;
    // $windowsize.r2 = $windowsize.w2 / $windowsize.h2;
    if (
      force ||
      $windowsize.w != oldWidth ||
      // $windowsize.w2 != oldWidth2 ||
      $windowsize.h != oldHeight ||
      $windowsize.h2 != oldHeight2
    ) {
      $windowsize.resizeAll();
    }
  },

  // ======================================================================
  // GENERAL RESIZE CALLBACKS
  // ======================================================================

  resizeAll: function() {
    $windowsize.resizeCommon();
    $pages.resetAfterResize();
    $scroll.resize();
    $animate.resize();
  },

  // resize elements on a new page before animating to it
  resizeNewPage: function() {
    $windowsize.resizeCommon();
    $scroll.resizeNewPage();
    $animate.resize();
  },

  resizeCommon: function() {
    $windowsize.checkDesktop();
    if (!$windowsize.isDesktop) {
      // mobile
      $windowsize.resizeMobileVH();
      $windowsize.resizeMobileMedia($pages.currentPage);
    } else {
      // desktop
      $windowsize.reRender();
      $windowsize.resizeDesktopVH($pages.currentPage);
      $windowsize.resizeDesktopMedia($pages.currentPage);
      $windowsize.resizeDesktopParagraphs($pages.currentPage);
    }
  },

  // ======================================================================
  // RESIZE STUFF
  // ======================================================================

  // check if in desktop / landscape mode
  // and reset injected styles
  checkDesktop: function() {
    if ($el('#js-desktop').is(':visible')) {
      // changed to desktop
      if (!$windowsize.isDesktop) {
        $windowsize.isDesktop = true;
        $windowsize.removeMobileStyles();
        $nav.hide($windowsize.initedNavResize ? false : true);
      }
    } else {
      // changed to mobile
      if ($windowsize.isDesktop) {
        $windowsize.isDesktop = false;
        $windowsize.removeDesktopStyles();
        $nav.hide($windowsize.initedNavResize ? false : true);
      }
    }
    $windowsize.initedNavResize = true;
  },

  // hack that forces safari to re-render things properly
  // (vh font sizes, image aspect ratios)
  reRender: function() {
    $el('#wrapper')
      .hide()
      .show(0);
  },

  // remove any dynamically injected styles
  // when switching between desktop and mobile/tablet
  removeMobileStyles: function() {
    // resizeMobileVH
    $('.nav__scroll').css('height', '');
    $('.nav--has-news .nav__body').css('min-height', '');
    $('.page__hero--main').css('height', '');
    // resizeMobileMedia
    $('[data-ratio]').css('height', '');
  },
  removeDesktopStyles: function() {
    // resizeDesktopVH
    $('.row-lg-gutter').css({'padding-top': '', 'padding-bottom': ''});
    $('.row-lg-outset-top').css('margin-top', '');
    $("[class*='row-lg-offset-']").css('margin-top', '');
    $("[class*='logos--col-']").css('width', '');
    $('.nav__news-desktop').css('width', '');
    // resizeDesktopMedia
    $('[data-ratio]').css('width', '');
    // resizeDesktopParagraphs
    $('.row-lg-width-js').css('width', '');
  },

  // hack for stupid mobile / tablet browsers where 100vh is taller than the viewport
  resizeMobileVH: function() {
    var wrapperHeight = $windowsize.h;
    var vhHeight = $el('#js-vh').height();
    if (vhHeight > wrapperHeight || $device.ie || ($windowsize.devVH && vhHeight >= wrapperHeight)) {
      // nav
      $el('.nav__scroll').css('height', $windowsize.h2 + 'px');
      $el('.nav--has-news .nav__body').css('min-height', $windowsize.h2 * 0.94 + 'px');
      // hero
      $('.page__hero--main').css('height', $windowsize.h + 'px');
    }
  },

  // hack for stupid mobile / tablet browsers where 100vh is taller than the viewport
  resizeDesktopVH: function(page) {
    var wrapperHeight = $windowsize.h;
    var vhHeight = $el('#js-vh').height();
    if (vhHeight > wrapperHeight || $device.ie || ($windowsize.devVH && vhHeight >= wrapperHeight)) {
      var ratio = wrapperHeight / vhHeight;
      // row padding
      var selector1 = '.row-lg-gutter';
      var element1 = typeof page === 'string' ? $el('#page-' + page + ' ' + selector1) : $el(selector1);
      element1.css({'padding-top': '', 'padding-bottom': ''}).each(function() {
        var padding = parseFloat($(this).css('padding-top'));
        var newPadding = padding * ratio;
        $(this).css({
          'padding-top': newPadding,
          'padding-bottom': newPadding
        });
      });
      // row outset
      var selector2 = '.row-lg-outset-top';
      var element2 = typeof page === 'string' ? $el('#page-' + page + ' ' + selector2) : $el(selector2);
      element2.css({'margin-top': ''}).each(function() {
        var margin = parseFloat($(this).css('margin-top'));
        var newMargin = margin * ratio;
        $(this).css({
          'margin-top': newMargin
        });
      });
      // row offset
      var selector3 = "[class*='row-lg-offset-']";
      var element3 = typeof page === 'string' ? $el('#page-' + page + ' ' + selector3) : $el(selector3);
      element3.css({'margin-top': ''}).each(function() {
        var margin = parseFloat($(this).css('margin-top'));
        var newMargin = margin * ratio;
        $(this).css({
          'margin-top': newMargin
        });
      });
      // logos
      for (i = 1; i <= 8; i++) {
        var selector4 = '.logos--col-' + i;
        var element4 = typeof page === 'string' ? $el('#page-' + page + ' ' + selector4) : $el(selector4);
        element4.css({
          width: 30 * i * ratio + 'vh'
        });
      }
      // nav grid
      var element5 = $el('nav').find("[class*='row-lg-offset-']");
      element5.css({'margin-top': ''}).each(function() {
        var margin = parseFloat($(this).css('margin-top'));
        var newMargin = margin * ratio;
        $(this).css({
          'margin-top': newMargin
        });
      });
      // nav news
      var element6 = $el('nav').find('.nav__news-desktop');
      var newsRatio = 700 / 1000;
      var newsWidth = $windowsize.h * newsRatio;
      element6.css({
        width: newsWidth
      });
    }
  },

  // set media aspect ratios properly
  resizeMobileMedia: function(page) {
    if (page !== null) {
      var selector = '[data-ratio]';
      var element = typeof page === 'string' ? $el('#page-' + page + ' ' + selector) : $el(selector);
      element.each(function() {
        var ratio = $(this).attr('data-ratio');
        var width = $(this).width();
        var height = Math.round(width / ratio);
        $(this).css('height', height);
      });
    }
  },

  // set media aspect ratios properly
  resizeDesktopMedia: function(page) {
    if (page !== null) {
      var selector = '[data-ratio]';
      var element = typeof page === 'string' ? $el('#page-' + page + ' ' + selector) : $el(selector);
      element.each(function() {
        var ratio = $(this).attr('data-ratio');
        var height = $(this).height();
        var width = Math.round(height * ratio);
        $(this).css('width', width);
      });
    }
  },

  // set widths of text elements that have fixed height
  resizeDesktopParagraphs: function(page) {
    if (page !== null) {
      var selector = '.row-lg-width-js';
      var element = typeof page === 'string' ? $el('#page-' + page + ' ' + selector) : $el(selector);
      element.each(function() {
        $(this).css('width', '');
        var child = $(this).find('.js-overflow');
        if (child.length > 0) {
          $windowsize.resizeDesktopParagraphHeightLoop($(this), child, 0);
        }
      });
    }
  },
  resizeDesktopParagraphHeightLoop: function(parent, child, loop) {
    if (loop < 30) {
      var parent_height = parent.height();
      var child_height = child.outerHeight();
      if (parent_height <= 0) {
        return;
      }
      if (child_height > parent_height + 5) {
        var new_width = parseInt(parent.width()) * 1.08;
        parent.css({
          width: new_width
        });
        $windowsize.resizeDesktopParagraphHeightLoop(parent, child, loop + 1);
      } else {
        $windowsize.resizeDesktopParagraphWidthLoop(parent, child, 0);
      }
    }
  },
  resizeDesktopParagraphWidthLoop: function(parent, child, loop) {
    if (loop < 30) {
      var parent_width = parent.width();
      var child_width = child[0].scrollWidth;
      if (child_width > parent_width + 5) {
        var new_width = parseInt(parent.width()) * 1.08;
        parent.css({
          width: new_width
        });
        $windowsize.resizeDesktopParagraphWidthLoop(parent, child, loop + 1);
      }
    }
  }
};
